module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GXY_3X.7a0eae41.tom";